<template>
    <v-layout row>
        <v-flex md2 class="pa-0">
            <sub-side-bar :items="settingsMenu"></sub-side-bar>
        </v-flex>
        <v-flex md10>
            <router-view/>
        </v-flex>
    </v-layout>

</template>

<script>
    import subSideBar from "../components/common/subSideBar";
    export default {
        name: "settings",
        components: {
            subSideBar
        },
        data () {
            return {
                settingsMenu: {
                    title: 'Settings',
                    menu: [
                        {
                            title: 'General Settings',
                            items: [
                                {
                                    title: 'Channel Configuration',
                                    link: '/settings/channel-configuration'
                                },
                                {
                                    title: 'Google Reviews',
                                    link: '/settings/google-reviews'
                                },
                                {
                                    title: 'Facebook Pages',
                                    link: '/settings/facebook-pages'
                                },
                                {
                                    title: 'Twitter Integration',
                                    link: '/settings/twitter'
                                },
                                {
                                    title: 'Agent Keyword Filter',
                                    link: '/settings/bad-words'
                                },
                                {
                                  title: 'Bots Versions',
                                  link: '/settings/versions'
                                }
                            ],
                        },
                        {
                            title: 'Widget Configuration',
                            items: [
                                {
                                    title: 'Forms',
                                    link: '/settings/forms'
                                },
                                {
                                  title: 'Intro Buttons',
                                  link: '/settings/intro-buttons'
                                },
                                {
                                    title: 'Menus',
                                    link: '/settings/menus'
                                },
                                {
                                    title: 'FAQs',
                                    link: '/settings/faqs'
                                },
                                {
                                    title: 'Configure Notifications',
                                    link: '/settings/notifications'
                                },
                            ],
                        }
                    ]
                }
            }
        },
    }
</script>

<style scoped>
    .btn-input {
        height: 45px;
    }
    .add-lang {
        max-width: 500px;
        margin: auto;
    }
</style>
